// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-64c54389]{will-change:height;transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.expand-enter-active[data-v-64c54389],.expand-leave-active[data-v-64c54389]{transition:height .6s cubic-bezier(.63,.47,.21,.9);overflow:hidden}.expand-enter[data-v-64c54389],.expand-leave-to[data-v-64c54389]{height:0}", ""]);
// Exports
module.exports = exports;
